import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDiscordBotsQueryVariables = Types.Exact<{
  ownerUserId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  ownerTeamId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;

export type GetDiscordBotsQuery = {
  __typename?: 'Query';
  discordBots: Array<{
    __typename?: 'DiscordBot';
    id: any;
    botUsername?: string | null;
    guildName?: string | null;
    isActive: boolean;
    createdAt: any;
  }>;
};

export const GetDiscordBotsDocument = gql`
  query GetDiscordBots($ownerUserId: UUID, $ownerTeamId: UUID) {
    discordBots(ownerUserId: $ownerUserId, ownerTeamId: $ownerTeamId) {
      id
      botUsername
      guildName
      isActive
      createdAt
    }
  }
`;

/**
 * __useGetDiscordBotsQuery__
 *
 * To run a query within a React component, call `useGetDiscordBotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscordBotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscordBotsQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      ownerTeamId: // value for 'ownerTeamId'
 *   },
 * });
 */
export function useGetDiscordBotsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDiscordBotsQuery,
    GetDiscordBotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDiscordBotsQuery, GetDiscordBotsQueryVariables>(
    GetDiscordBotsDocument,
    options,
  );
}
export function useGetDiscordBotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDiscordBotsQuery,
    GetDiscordBotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDiscordBotsQuery, GetDiscordBotsQueryVariables>(
    GetDiscordBotsDocument,
    options,
  );
}
export function useGetDiscordBotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDiscordBotsQuery,
        GetDiscordBotsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDiscordBotsQuery,
    GetDiscordBotsQueryVariables
  >(GetDiscordBotsDocument, options);
}
export type GetDiscordBotsQueryHookResult = ReturnType<
  typeof useGetDiscordBotsQuery
>;
export type GetDiscordBotsLazyQueryHookResult = ReturnType<
  typeof useGetDiscordBotsLazyQuery
>;
export type GetDiscordBotsSuspenseQueryHookResult = ReturnType<
  typeof useGetDiscordBotsSuspenseQuery
>;
export type GetDiscordBotsQueryResult = Apollo.QueryResult<
  GetDiscordBotsQuery,
  GetDiscordBotsQueryVariables
>;
